import { Component, Input, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ItemWithStatus, OperationValidationItem } from '@app/control-panel/models/control-panel.model';

@Component({
  selector: 'scf-operation-validation-table',
  templateUrl: './operation-validation-table.component.html',
  styleUrls: ['./operation-validation-table.component.scss'],
})
export class OperationValidationTableComponent implements OnInit {
  @Input() item: ItemWithStatus;
  status: string;

  dataSource = new MatTableDataSource<OperationValidationItem>();

  displayedColumns: string[] = [
    'agent',
    'numContract',
    'documentHolder',
    'document',
    'documentSituation',
    'incidenceDate',
    'formalizedDate',
    'expirationDate',
  ];

  constructor() {}

  ngOnInit() {
    this.status = this.item.statusDesc;
    this.dataSource.data = this.item.items;
  }
}
